import { motion } from 'framer-motion';
import V8_1 from '../../assets/images/home/vector8/vector8-1.svg';
import V8_2 from '../../assets/images/home/vector8/vector8-2.svg';
import V8_3 from '../../assets/images/home/vector8/vector8-3.svg';
import V8_4 from '../../assets/images/home/vector8/vector8-4.svg';
import V8_5 from '../../assets/images/home/vector8/vector8-5.svg';
import V8_6 from '../../assets/images/home/vector8/vector8-6.svg';
import V8_7 from '../../assets/images/home/vector8/vector8-7.svg';

const Vector8 = () => {
  return (
    <motion.div className="vector" id="vector8"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.9 }}
    >
      <img src={V8_1} alt="Décoration à droite" />
      <img src={V8_2} alt="Décoration à droite" />
      <img src={V8_3} alt="Décoration à droite" />
      <img src={V8_4} alt="Décoration à droite" />
      <img src={V8_5} alt="Décoration à droite" />
      <img src={V8_6} alt="Décoration à droite" />
      <img src={V8_7} alt="Décoration à droite" />
    </motion.div>
  );
};

export default Vector8;